import * as React from 'react';

declare const rootUrl: string;

interface PreparationStepsProps {
    onNext: () => void;
}

export const PreparationSteps = ({ onNext }: PreparationStepsProps) => {
    return (
        <>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="text-primary">Prepare Device</h2>
                    </div>
                    <div className="col-md-12">
                        <ol className="posh-list">
                            <li>Unscrew the back cover of the device using the screwdriver provided and remove the back cover of the device</li>
                            <li>Pull out the tab on the inside of the VitaloJAK to open the CF card slot</li>
                            <li>Insert the card into the device with the manufacturer label facing the battery compartment then close the CF card slot tab</li>
                            <li>Use the tweezers to push the CF card fully into the slot and ensure the top of the CF card is level with the black button inside the slot</li>
                            <li>Insert the new battery pack by plugging in the connector from the battery pack in to the connector in the battery compartment</li>
                            <li>Fit the battery pack inside the compartment with the plug along the top of the battery pack</li>
                            <li>Reattach the back cover and fasten it closed with the screw.</li>
                        </ol>
                    </div>
                    <div className="col-md-12 text-center">
                        <img style={{ width: '100%', maxWidth: '500px' }} src={rootUrl + 'Content/Images/Wizards/vitalojak1-2.png'} alt="" />
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-primary" onClick={onNext}>Next</button>
            </div>
        </>
    );
}
